export class CredentialNumberSettings {
  id: string;
  prefix: string;
  start: number;
  minimumDigits: number;

  constructor(data?: CredentialNumberSettings) {
    if (!data) return;
    this.id = data.id;
    this.prefix = data.prefix;
    this.start = data.start;
    this.minimumDigits = data.minimumDigits;
  }
}
